import {createStore, applyMiddleware} from 'redux';
import rootReducer from '../reducers/main.js';
import thunkMiddleware from 'redux-thunk';
import {routerMiddleware} from 'react-router-redux';

import {persistStore, persistReducer} from 'redux-persist';
import storage from 'redux-persist/lib/storage';

const persistConfig = {
  key: 'root',
  storage,
};

const persistedReducer = persistReducer(persistConfig, rootReducer);

const storeContainer = (history) => {
  const routerMware = routerMiddleware(history);
  let store = createStore(
    persistedReducer,
    applyMiddleware(thunkMiddleware, routerMware)
  );
  let persistor = persistStore(store);
  return {store, persistor};
};
export default storeContainer;
